module.exports = __webpack_public_path__ + "img/img05.40a6d2af.svg";